<template>
  <div :class="['toggle-switch', { 'is-checked': isChecked }]" :style="{ width: trackWidth + 'px', height: height + 'px' }">
    <input type="checkbox" :id="id" v-model="isChecked" @change="handleChange" />
    <label :for="id" :style="{ height: height + 'px', width: trackWidth + 'px' }">
      <span
        class="toggle"
        :style="{
          width: toggleSize + 'px',
          height: toggleSize + 'px',
          top: (height - toggleSize) / 2 + 'px',
          transform: isChecked ? 'translateX(' + (trackWidth - toggleSize) + 'px)' : 'translateX(0)'
        }"
      ></span>
    </label>
  </div>
</template>

<script setup>
import { ref, defineProps, defineEmits, watch, computed } from 'vue';

const emit = defineEmits(['update:modelValue']);
const props = defineProps({
  modelValue: {
    type: Boolean,
    default: false,
  },
  id: {
    type: String,
    default: 'toggle-switch',
  },
  width: {
    type: Number,
    default: 25, // Дефолтное значение
  },
  height: {
    type: Number,
    default: 23, // Дефолтное значение
  },
  toggleSize: {
    type: Number,
    default: 30, // Дефолтное значение
  },
});

const isChecked = ref(props.modelValue);

const trackWidth = computed(() => props.width * 2.5)

watch(() => props.modelValue, (newValue) => {
  isChecked.value = newValue;
});

const handleChange = () => {
  emit('update:modelValue', isChecked.value);
};
</script>

<style scoped>
.toggle-switch {
  display: inline-block;
  position: relative;
}
input[type='checkbox'] {
  display: none;
}
label {
  background: #252525;
  border-radius: 50px;
  display: block;
  position: relative;
  transition: background 0.4s;
}
label .toggle {
  background: #868080;
  border-radius: 50%;
  position: absolute;
  transition: transform 0.4s;
  left: 0;
}
.is-checked label {
  background: #474747;
}
</style>
